import React, {Component} from 'react';
import "./App.css";
import Lachen from "./Bilder/lachen.JPG";
import FFP2 from "./Bilder/FFP.jpg";
import FFP22 from "./Bilder/FFP2-2.jpg";

class Aerzte extends Component {


	UNSAFE_componentWillMount(){
		window.scrollTo(0,0);
	}

render() {	
  return (	

	<div className="homeApp">

	
	<img src={Lachen} className="M11" alt="Lachen" />	
	
	<div className="contentHome, Maske">	
	
	<h2>Schützen Masken<br/>oder sind sie schädlich?</h2>
	  
	
		
		<div className="Ein">	
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=yhlNwlW9LXg" target="_blank" >
				Lauterbach schlägt wieder Corona-Alarm: „Es verschlägt einem die Sprache“ 25.08.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://tkp.at/2022/05/04/studie-ueber-masken-in-europa-schaden-ohne-nutzen/" target="_blank" >
			Studie über Masken in Europa: Schaden ohne Nutzen 04.05.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://soundcloud.com/radiomuenchen/kinder-als-opfer-einer-angstkultur" target="_blank" >
			Kinder als Opfer einer Angstkultur 30.04.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Ydo_8pHUeT4" target="_blank" >
				Jetzt rächt sich die Verächtlichmachung der Maßnahmen-Kritiker! (Raphael Bonelli) 05.04.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=00OKDDGhVP4" target="_blank" >
				Maskenzwang in Schulen , Bill Gates und China, digitaler Impfpass | Der Kaiser ist nackt 02.03.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://tkp.at/2022/02/22/maskenpflicht-kann-zu-dauerhafter-schaedigung-von-kindern-fuehren/" target="_blank" >
			Maskenpflicht kann zu dauerhafter Schädigung von Kindern führen 22.02.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.zdf.de/nachrichten/panorama/corona-ffp2-masken-zweifel-100.html" target="_blank" >
			ZDF-heute: EU-Behörde zweifelt am Nutzen von FFP2-Masken 04.02.2022
			</a>	
			<a className="videoText" rel="noopener"  href="https://www.express.de/ratgeber/verbraucher/warnung-vor-ffp2-masken-fuenf-modelle-betroffen---bei-einem-droht-sogar-lebensgefahr-38470394?cb=1623997328736" target="_blank" >
				Warnung vor FFP2-Masken 18.06.2021
			</a>

			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=eTZV4VldUIg" target="_blank" >
				Keine Masken für Mütter 06.05.2021
			</a>			
			<a className="videoText" rel="noopener"  href="https://reitschuster.de/post/massive-gesundheitsschaedigung-durch-masken/" target="_blank" >
				Massive Gesundheitsschädigung durch Masken 20.04.2021
			</a>			
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=s2xbM7UOhN4" target="_blank" >
				Neurologin Margareta Griesz Brisson
			</a>
			
			<a className="videoText" rel="noopener"  href="https://reitschuster.de/post/sind-masken-fuer-kinder-gefaehrlich-ein-immunologe-rechnet-ab/" target="_blank" >
				"Generation Maske" Prof. Hockertz 27.03.2021
			</a>			
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=XP6lBZXxt18" target="_blank" >
				Dr. Paul Brandenburg kritisiert Ärztekammer 14.01.2021
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=QIRxLEUGBDw" target="_blank" >
				Beschluss des Amtsgerichts Weimar vom 08.04.2021<br/>
				Was kann man damit machen?
			</a>			
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=gD-SaOcNNpo" target="_blank" >
				Maske als Zwangsmassnahme 28.01.2021
			</a>			
			<a className="videoText" rel="noopener"  href="https://www.rtl.de/cms/rki-ffp2-masken-nicht-zur-privaten-nutzung-empfohlen-wie-passt-das-zur-maskenpflicht-4689496.html" target="_blank" >
				RKI rät von FFP2-Masken im Alltag ab 24.01.2021
			</a>								
			
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=rxXr_1TLwCs" target="_blank" >
				Die Psychologie der<br/>Mitläufer & Masken-Liebhaber<br/>10.12.2020
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=OsnD342EwqU&t=1456s" target="_blank" >
				Gunnar Kaiser 	15.08.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=V1ukbrD0jjk" target="_blank" >
				Gabriele Knabbe	10.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.frei3.de/article/505e6eb8-4d31-4150-a0e0-df5468542f34" target="_blank" >
				Klartext	13.09.2020
			</a>			
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=EvTwBhSREYw" target="_blank" >
				Lutz Männel	06.07.2020
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=ygDoiJICtj0"  target="_blank">
						Amtseid der Kanzlerin
			</a>			
		</div>

	</div>
	
	<img src={Lachen} className="M12" alt="Lachen" />		
	
	<div className="Bilder">
		<img src={FFP2} className="M2" alt="FFP2" />	
		<img src={FFP22} className="M3" alt="FFP2" />	
	</div>

</div>
	 
  );
};
};

export default Aerzte;
